<template>
  <div class="page-box" style="position: relative;">
    <el-form ref="temporaryWorkFeedbackFilter" :model="temporaryWorkFeedback" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350"
        @search="refreshTemporaryWorkFeedback(true)"
        @reset="onResetTemporaryWorkFeedback"
      >
        <el-form-item label="是否完成" prop="formFilter.dealStatus">
          <el-select class="filter-item" v-model="temporaryWorkFeedback.formFilter.dealStatus" :clearable="true" filterable
            placeholder="是否完成" :loading="temporaryWorkFeedback.dealStatus.impl.loading"
            @visible-change="temporaryWorkFeedback.dealStatus.impl.onVisibleChange"
            @change="onDealStatusValueChange">
            <el-option v-for="item in temporaryWorkFeedback.dealStatus.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否超时" prop="formFilter.isLate">
          <el-select class="filter-item" v-model="temporaryWorkFeedback.formFilter.isLate" :clearable="true" filterable
            placeholder="是否超时" :loading="temporaryWorkFeedback.isLate.impl.loading"
            @visible-change="temporaryWorkFeedback.isLate.impl.onVisibleChange"
            @change="onIsLateValueChange">
            <el-option v-for="item in temporaryWorkFeedback.isLate.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetTemporaryWorkFeedback">重置</el-button>

        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTemporaryWorkFeedback(true)">查询
        </el-button>
      </filter-box>
    </el-form>
      <el-table ref="temporaryWorkFeedback" header-cell-class-name="table-header-gray"
        :data="temporaryWorkFeedback.TemporaryWorkFeedback.impl.dataList" :size="defaultFormItemSize"
        @sort-change="temporaryWorkFeedback.TemporaryWorkFeedback.impl.onSortChange"
        @refresh="refreshTemporaryWorkFeedback(true)"
      >
        <!-- 表格操作 -->
        <!-- 表格列 -->
        <el-table-column label="序号" type="index" width="50px"
                    :index="temporaryWorkFeedback.TemporaryWorkFeedback.impl.getTableIndex" />
        <el-table-column label="创建人" prop="createUserIdDictMap.name" />
        <el-table-column label="接收人" prop="receiveUserName" />
        <el-table-column label="是否完成" prop="dealStatusDictMap.name" />
        <el-table-column label="是否超时" prop="isLateDictMap.name">
        </el-table-column>
        <el-table-column label="完成时间" prop="dealTime">
          <template slot-scope="scope">
            <span>{{formatDateByStatsType(scope.row.dealTime, 'day')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="考核分数" prop="assessmentScore" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
<!--            <el-button @click.stop="onScoreClick(scope.row)" type="text" :size="defaultFormItemSize"-->
<!--                       :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')">-->
<!--              考核-->
<!--            </el-button>-->
            <el-button @click.stop="onDetailClick(scope.row)" type="text" :size="defaultFormItemSize"
            >
              查看
            </el-button>
<!--            <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"-->
<!--                       :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:delete')">-->
<!--              删除-->
<!--            </el-button>-->
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty unified-font">
            <img src="@/assets/img/empty.png">
            <span>暂无数据</span>
          </div>
        </template>

      </el-table>
    <!-- 分页 -->
    <el-row slot="pagination" type="flex" justify="end" style="margin-top: 10px;">
      <el-pagination
        :total="temporaryWorkFeedback.TemporaryWorkFeedback.impl.totalCount"
        :current-page="temporaryWorkFeedback.TemporaryWorkFeedback.impl.currentPage"
        :page-size="temporaryWorkFeedback.TemporaryWorkFeedback.impl.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, prev, pager, next, sizes"
        @current-change="temporaryWorkFeedback.TemporaryWorkFeedback.impl.onCurrentPageChange"
        @size-change="temporaryWorkFeedback.TemporaryWorkFeedback.impl.onPageSizeChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { TemporaryWorkFeedbackController, DictionaryController } from '@/api';

export default {
  name: 'temporaryWorkFeedback',
  props: {
    workId: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      temporaryWorkFeedback: {
        formFilter: {
          dealStatus: undefined,
          isLate: undefined
        },
        formFilterCopy: {
          dealStatus: undefined,
          isLate: undefined
        },
        dealStatus: {
          impl: new DropdownWidget(this.loadDealStatusDropdownList)
        },
        isLate: {
          impl: new DropdownWidget(this.loadIsLateDropdownList)
        },
        TemporaryWorkFeedback: {
          impl: new TableWidget(this.loadTemporaryWorkFeedbackWidgetData, this.loadTemporaryWorkFeedbackVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetTemporaryWorkFeedback () {
      this.$refs.temporaryWorkFeedbackFilter.resetFields();
      this.refreshTemporaryWorkFeedback(true);
    },
    /**
     * 临时性工作反馈数据获取函数，返回Promise
     */
    loadTemporaryWorkFeedbackWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        temporaryWorkFeedbackDtoFilter: {
          dealStatus: this.temporaryWorkFeedback.formFilterCopy.dealStatus,
          isLate: this.temporaryWorkFeedback.formFilterCopy.isLate,
          workId: this.workId
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        TemporaryWorkFeedbackController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 临时性工作反馈数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadTemporaryWorkFeedbackVerify () {
      this.temporaryWorkFeedback.formFilterCopy.dealStatus = this.temporaryWorkFeedback.formFilter.dealStatus;
      this.temporaryWorkFeedback.formFilterCopy.isLate = this.temporaryWorkFeedback.formFilter.isLate;
      return true;
    },
    /**
     * 完成状态1完成下拉数据获取函数
     */
    loadDealStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 完成状态1完成选中值改变
     */
    onDealStatusValueChange (value) {
    },
    /**
     * 是否超时0否1是下拉数据获取函数
     */
    loadIsLateDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否超时0否1是选中值改变
     */
    onIsLateValueChange (value) {
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };
      this.$confirm('确认删除？').then(res => {
        TemporaryWorkFeedbackController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.temporaryWorkFeedback.TemporaryWorkFeedback.impl.refreshTable(false, 1);
        }).catch(e => {});
      }).catch(e => {});
    },
    onScoreClick () {

    },
    onDetailClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'temporaryWorkFeedbackForm', query: params});
    },
    /**
     * 更新临时工作反馈情况
     */
    refreshTemporaryWorkFeedback (reloadData = false) {
      if (reloadData) {
        this.temporaryWorkFeedback.TemporaryWorkFeedback.impl.refreshTable(true, 1);
      } else {
        this.temporaryWorkFeedback.TemporaryWorkFeedback.impl.refreshTable();
      }
      if (!this.temporaryWorkFeedback.isInit) {
        // 初始化下拉数据
      }
      this.temporaryWorkFeedback.isInit = true;
    },
    onResume () {
      this.refreshTemporaryWorkFeedback();
    },
    initFormData () {
    },
    formInit () {
      this.refreshTemporaryWorkFeedback();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
